import { render, staticRenderFns } from "./ConfigurationSpecifications.vue?vue&type=template&id=0da58814&"
import script from "./ConfigurationSpecifications.vue?vue&type=script&lang=ts&"
export * from "./ConfigurationSpecifications.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports